module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "GEQB-EBNative-1.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('h2', {
    attrs: {
      "id": "toc_marker-1"
    }
  }, [_vm._v("TABLE OF CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('a', {
    attrs: {
      "href": "#/GEQBEBNative2#Anchor-5"
    }
  }, [_vm._v("ABOUT THIS BOOK")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('a', {
    attrs: {
      "href": "#/GEQBEBNative3#Anchor-6"
    }
  }, [_vm._v("MUFFINS AND SWEET ROLLS")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('a', {
    attrs: {
      "href": "#/GEQBEBNative3#Anchor-14"
    }
  }, [_vm._v("Chocolate-Chip Muffins")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('a', {
    attrs: {
      "href": "#/GEQBEBNative3#Anchor-15"
    }
  }, [_vm._v("Cherry Bran Muffins")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('a', {
    attrs: {
      "href": "#/GEQBEBNative3#Anchor-16"
    }
  }, [_vm._v("Applesauce Muffins")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('a', {
    attrs: {
      "href": "#/GEQBEBNative3#Anchor-17"
    }
  }, [_vm._v("Heartland Apple Nut Muffins")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('a', {
    attrs: {
      "href": "#/GEQBEBNative3#Anchor-18"
    }
  }, [_vm._v("Favorite Oat Bran Muffins")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('a', {
    attrs: {
      "href": "#/GEQBEBNative3#Anchor-19"
    }
  }, [_vm._v("Cinnamon Rolls")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('a', {
    attrs: {
      "href": "#/GEQBEBNative3#Anchor-20"
    }
  }, [_vm._v("Bobbie Mellulis’ Cinnamon Rolls")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative4#Anchor-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PANCAKES")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative4#Anchor-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heavenly Hots")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative4#Anchor-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Homemade Pancake Mix")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative4#Anchor-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fresh Blueberry Pancakes")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative4#Anchor-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Foolproof Pancakes")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative4#Anchor-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oatmeal Pancakes")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative4#Anchor-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oatmeal Pecan Pancakes")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative4#Anchor-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pumpkin Flapjacks with Cider Walnut Syrup")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative5#Anchor-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SCONES")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative5#Anchor-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Scones")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative5#Anchor-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Irish Scones")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative5#Anchor-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mary Dugan’s Currant Scones")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative5#Anchor-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheese Scones")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative5#Anchor-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mocha Scones")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative6#Anchor-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BISCUITS")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative6#Anchor-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Classic Golden Buttermilk Biscuits")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative6#Anchor-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Potato and Spice Biscuits")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative6#Anchor-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Melted Cheddar-Glazed Biscuits")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative6#Anchor-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sherry Currant Tea Biscuits")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative6#Anchor-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baking-Powder Drop Biscuits")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative7#Anchor-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SAVORY LOAVES AND CORNBREADS")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative7#Anchor-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mary Foley’s Soda Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative7#Anchor-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Irish Soda Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative7#Anchor-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative7#Anchor-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sauerkraut Beer Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative7#Anchor-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet-Potato Hush Puppies")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative7#Anchor-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cornbread with Honey Sage Butter")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative7#Anchor-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jalapeno Corn Muffins")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative8#Anchor-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SWEET LOAVES")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative8#Anchor-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banana Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative8#Anchor-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tasty Cranberry-Orange Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative8#Anchor-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Quick Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative8#Anchor-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Standoffish Cinnamon Loaf")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative8#Anchor-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orange Zest Date-Nut Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative8#Anchor-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Favorite Pumpkin Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative8#Anchor-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maui Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative8#Anchor-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whole Wheat Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative8#Anchor-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strawberry Quick Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative8#Anchor-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zucchini Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative8#Anchor-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poppyseed Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative9#Anchor-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CAKES")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative9#Anchor-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pineapple Upside Down Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative9#Anchor-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prize-Winning Persimmon Pudding")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative9#Anchor-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Indiana-Style Persimmon Pudding")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative9#Anchor-59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Linda Bland’s Coconut-Pineapple Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative9#Anchor-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mary Meade’s White Fruitcake")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative9#Anchor-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Shortcake with Fresh Berries")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/GEQBEBNative10#Anchor-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SOURCES")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71f5e28c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GEQBEBNative1.vue
// module id = 60
// module chunks = 0